import React from "react";
import "./style/App.scss";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ListPage } from "./components/pages/list/ListPage";
import { AfishaLayout, AfishaHome, AfishaAboutPage, AfishaChannelsPage, AfishaChannelPage } from "./components/pages/afisha/AfishaPage";
import { OrgPage } from "./components/pages/org/OrgPage";
import { CreateEventPage } from "./components/pages/create/CreateEventPage";
import { InfoPage } from "./components/pages/about/InfoPage";
import { SingleEventPage } from "./components/pages/singeEvent/SingleEventPage";
import { EditEventPage } from "./components/pages/edit/EditEventPage";
import { CheckPageWrapper } from "./components/pages/checkPage/CheckPage";
import { AdminService } from "./services/AdminService";
import { FIlterPage } from "./components/pages/filter/FilterPage";
import { SearchPage } from "./components/pages/search/SearchPage";
import { TestPage } from "./components/pages/test/TestPage";
import { LikesPage } from "./components/pages/likes/LikesPage";

const routes = [
  {
    path: "/",
    element: <AfishaLayout />,
    children: [
      {
        index: true,
        element: <AfishaHome />,
      },
      {
        path: "about",
        element: <AfishaAboutPage />,
      },
      {
        path: "channels",
        children: [
          {
            index: true,
            element: <AfishaChannelsPage />,
          },
          {
            path: ":name",
            element: <AfishaChannelPage />,
          },
        ],
      },
    ],
  },
  {
    path: "/list",
    element: <ListPage />,
  },
  {
    path: "/filter",
    element: <FIlterPage />,
  },
  {
    path: "/org",
    element: <OrgPage />,
  },
  {
    path: "/info",
    element: <InfoPage />,
  },
  {
    path: "/likes",
    element: <LikesPage />,
  },
  {
    path: "/create",
    element: <CreateEventPage />,
  },
  {
    path: "/events/:eventId",
    element: <SingleEventPage />,
  },
  {
    path: "/edit/:eventId",
    element: <EditEventPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/test",
    element: <TestPage />,
  },
];

if (AdminService.getService().isAdmin()) {
  routes.push({
    path: "/checker",
    element: <CheckPageWrapper />,
  });
}
const router = createBrowserRouter(routes);

export const App = () => {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
};
